import { type ReactNode } from 'react'
import { TitleLarge } from '~/@mid_ui/typography/TitleLarge'

type Props = { headingText: ReactNode }

export function StepHeadline({ headingText }: Props) {
  return (
    <TitleLarge className="text-3xl font-semibold leading-9 lg:text-4xl lg:leading-[42px]">
      {headingText}
    </TitleLarge>
  )
}
